export default [
  {
    type: 'small',
    children: [
      {
        desc: 'I reconnected. Love your work. I am realigning myself and will be moving to branding with your firm in the next 6 months.',
        img: '/images/landing/new-homepage/testimonials-grid/susan-gupta.jpg',
        org: 'Susan Gupta',
        name: 'Sutton Real Estate',
        location: 'Toronto',
        type: 'small',
      },
      {
        desc: 'Excellent customer service and great products, they have awesome tools for realtors.',
        img: '/images/landing/new-homepage/testimonials-grid/CARMEN-ABRAHAM.jpg',
        org: 'Carmen Abraham ',
        name: 'Keller Williams Realty',
        location: 'Los Angeles',
        type: 'small',
      },
    ],
  },
  {
    type: 'big',
    children: [
      {
        desc: 'Your videos are beyond amazing and on point regarding content. You are so impressive as an artist and short film maker! Thank you for providing us with your AWESOME, INFORMATIVE VIDEOS!',
        img: '/images/landing/new-homepage/testimonials-grid/jean-esop.jpg',
        org: 'Jean E. Esop',
        name: 'Coldwell Banker Village Prop',
        location: 'San Diego',
        type: 'big',
      },
    ],
  },
  {
    type: 'video',
    children: [
      {
        desc: "I love the content, I think it's excellent. It's short and sweet just the way I like things, cause everybody's in a hurry. We really want one -- Right click on the video, right click on the link. they need that. We need that.",
        img: '/images/landing/new-homepage/testimonials-grid/judy-goldberg.png',
        video: 'https://roomvu.com/files/judith-goldberg.mp4',
        org: 'Judith Goldberg',
        name: 'Pacific Regent Realty',
        location: 'San Diego',
        type: 'video',
      },
    ],
  },
  {
    type: 'big',
    children: [
      {
        desc: 'People that follow me, they can see that I’m giving them good information that looks good, is up to date, that they can use and ask me more questions if they want to. The quality of what you’re doing is excellent. I have no question-it’s very very nice. ',
        img: '/images/landing/new-homepage/testimonials-grid/stan-weibe.png',
        org: 'Stan Wiebe',
        name: 'RE/MAX Little Oak Realty',
        location: 'Vancouver',
        type: 'video',
      },
    ],
  },
  {
    type: 'small',
    children: [
      {
        desc: 'Oh and I love your service, have a great day!',
        img: '/images/landing/new-homepage/testimonials-grid/steven-james.jpg',
        org: 'Steven James Spiro',
        name: 'Maritime Properties',
        location: 'Los Angeles',
        type: 'small',
      },
      {
        desc: 'Thanks for your help and for making this process look awesome!',
        img: '/images/landing/new-homepage/testimonials-grid/mario-preza.jpg',
        org: 'J. Mario Preza',
        name: 'Re/Max Gold Daly City',
        location: 'San Francisco',
        type: 'small',
      },
    ],
  },
  {
    type: 'big',
    children: [
      {
        desc: 'You give me the ability to present quality content. I regard you guys as my primary resource for content. Your videos are done with the quality and professionalism that’s consistent with the level of information that I want to share with my universe.',
        img: '/images/landing/new-homepage/testimonials-grid/craig-whitloc.jpg',
        org: 'Craig Whitlock',
        name: 'Coldwell Banker Realty | Brentwood',
        location: 'Los Angeles',
        type: 'big',
      },
    ],
  },
  {
    type: 'video',
    children: [
      {
        desc: 'Everybody knows videos get more eyeballs than static picture. What I like is having these videos, people can get the main gist of what I want to say in 30 seconds. You’re one of the first ones to post videos, this is why I didn’t even need a trial. ',
        img: '/images/landing/new-homepage/testimonials-grid/ramesh-rao.png',
        video: 'https://www.roomvu.com/files/ramesh-rao.mp4',
        org: 'Ramesh Rao',
        name: 'Coldwell Banker Residential Brokerage',
        location: 'San Francisco',
        type: 'video',
      },
    ],
  },
  {
    type: 'big',
    children: [
      {
        desc: 'Making calls is great but I like using Roomvu videos to connect with clients through email. I can use these videos to let clients know that I’m still thinking about them, taking the initiative to send them informative videos. ',
        img: '/images/landing/new-homepage/testimonials-grid/marcelo-cuello.jpg',
        org: 'Marcelo Cuello',
        name: 'RE/MAX West Realty',
        location: 'Toronto',
        type: 'big',
      },
    ],
  },
  {
    type: 'video',
    children: [
      {
        desc: 'I’m enjoying it, I like that the videos are short and I can put it out there and they can be effective. I’ve got great expectations, these videos workin’ for me!',
        img: '/images/landing/new-homepage/testimonials-grid/aubrey-hamid.png',
        video: 'https://www.roomvu.com/files/aubrey-hamid.mp4',
        org: 'Aubrey Hamid',
        name: 'Real Estate 360 Inc',
        location: 'Orlando',
        type: 'video',
      },
    ],
  },
  {
    type: 'small',
    children: [
      {
        desc: "I wanted to say I like your product. I'm nearing retirement, but if this was available 30 years ago, I would have been all over it.",
        img: '/images/landing/new-homepage/testimonials-grid/darren-martel.jpg',
        org: 'Darren Martel',
        name: 'Royal Lepage Connect Realty',
        location: 'Toronto',
        type: 'small',
      },
      {
        desc: 'I love your work.',
        img: '/images/landing/new-homepage/testimonials-grid/douglas-naguyen.jpg',
        org: 'Douglas Nguyen',
        name: 'Turnaround Asset Advisory',
        location: 'Los Angeles',
        type: 'small',
      },
    ],
  },
  {
    type: 'show-more',
    children: [],
  },
];
